export function isTokenBoxCellRenderer(cellRenderer) {
  return (cellRenderer === null || cellRenderer === void 0 ? void 0 : cellRenderer.getTokenBoxesForVisibleCell) !== undefined;
}
//# sourceMappingURL=TokenBoxCellRenderer.js.map